<div class="Dashboard">
  <div class="app-header">
    <div class="header">
      <div class="logo"><a> <img
            src="https://ciright-email-images.s3.amazonaws.com/other-images/ciright-white-logo.png"></a></div>
      <!-- <h2 class="h-title dev-team" style="padding-top: 14px;"> Career Netwprking Event </h2> -->
      <div class="right-content">
        <!-- <h2 class="h-title col-yellow" style="padding: 10px;"> <a>
            <button type="button" class="btn btn-primary">
              <img class="img-responsive" src="https://dummyimage.com/54x54/000/FFF"> abc
            </button>
          </a>
        </h2> -->

      </div>
      <!---->
    </div>
  </div>
</div>